import { useQuery } from "@tanstack/react-query";
import { fetchAllSalesLocations } from "../../services/locations.service";
import { INTERVAL } from "../../constants/clientTime";

export function useAllSalesLocationsForArticleQuery(fullId: string) {
  return useQuery({
    enabled: !!fullId,
    queryKey: ["allSalesLocations", fullId],
    queryFn: async () => {
      if (!fullId) {
        throw new Error("Invalid fullId");
      }
      return await fetchAllSalesLocations(fullId);
    },
    staleTime: 1 * INTERVAL.HOUR,
    initialData: !fullId ? [] : undefined,
  });
}
